export default __webpack_public_path__ + "static/media/MightyMagnets_03.0b73f7e3.png";